import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js'; 
import './Login.css';
import fondo from '../Imagenes/fondo_Login.jpg';
import logo from '../Imagenes/logo.png';
import cargando from '../Imagenes/Cargando.gif'
import { RUTAS_LOGIN } from "../Rutas";

const Login = () => {
  const navigate = useNavigate();
  const [usuario, setUsuario] = useState('');
  const [contrasena, setContrasena] = useState('');
  const [emailRecuperacion, setEmailRecuperacion] = useState('');
  const [mensajeConfirmacion, setMensajeConfirmacion] = useState('');
  const [cargandoLogin, setCargandoLogin] = useState(false);
  const [mensajeError, setMensajeError] = useState('');

  const manejarSubmit = async (e) => {
    e.preventDefault();
    setMensajeError('');
    setCargandoLogin(false);

    try {
      const response = await fetch(RUTAS_LOGIN.SINGIN, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: usuario, password: contrasena })
      });

      if (response.status === 200) {
        const data = await response.json();
        localStorage.setItem('token', data.token);
        localStorage.setItem('idUsuario', data.idUsuario); // Guarda el idUsuario
        localStorage.setItem('nombreUsuario', data.nombre); // Guarda el nombre
        localStorage.setItem('admin', data.admin); // Guarda el admin
        localStorage.setItem('roles', JSON.stringify(data.roles)); // Guarda los roles como JSON string
        setCargandoLogin(true);
        // Esperar 3 segundos antes de redirigir
        setTimeout(() => { navigate('/Home'); }, 3000);
      } else if (response.status === 401) {
        const message = await response.text();
        setMensajeError(`❌ ${message}`);
      } else if (response.status === 409) {
        const message = await response.text();
        setMensajeError(`❌ ${message}`);
      } else {
        const errorJson = await response.json();
        setMensajeError('❌ Error inesperado al iniciar sesión.' + errorJson);
      }
    } catch (error) {
      setMensajeError('❌ Error de conexión con el servidor.');
    }
  };

  const enviarRecuperacion = async () => {
    try {
      const response = await fetch(RUTAS_LOGIN.GET_PASS, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ usuario: emailRecuperacion })  
      });

      if (response.status === 200) { 
        setMensajeConfirmacion('✅ Si el correo está registrado, recibirás un email.'); 
      } else { 
        setMensajeConfirmacion('⚠️ Error al enviar el correo. Inténtalo de nuevo.'); 
      }
      
    } catch (error) {
      console.error('Error:', error);
      setMensajeConfirmacion('❌ Error inesperado al intentar recuperar la contraseña.');
    }
  };

  return (
    <div className="login-wrapper">
      <div className="login-image" style={{ backgroundImage: `url(${fondo})` }}></div>

      <div className="login-form-container">
        <center>
          <img className="logo-image mb-5" src={logo} alt="Logo empresa" />
        </center>
        <h2 className="titilos mb-5">Inicio de sesión</h2>
        <form onSubmit={manejarSubmit}>
          <div className="mb-3">
            <input
              type="text"
              className="form-control"
              placeholder="Usuario"
              value={usuario}
              onChange={(e) => setUsuario(e.target.value)}
            />
          </div>
          <div className="mb-3">
            <input
              type="password"
              className="form-control"
              placeholder="Contraseña"
              value={contrasena}
              onChange={(e) => setContrasena(e.target.value)}
            />
          </div>

          {mensajeError && (
            <div className="alert alert-danger text-center">{mensajeError}</div>
          )}

          <button type="submit" className="btn btn-primary w-100 rounded-4">
            Entrar
          </button>

          <div className="text-end mt-2">
            <button
              type="button"
              className="text-decoration-none btn btn-link p-0"
              data-bs-toggle="modal"
              data-bs-target="#modalRecuperar"
            >
              ¿Olvidaste tu contraseña?
            </button>
          </div>
           
          {/* Solo se muestra cuando es correcto */}
          {cargandoLogin && (
            <center>
              <img className="cargando-image mb-5" src={cargando} alt="Cargando..." />
            </center>
          )}
        </form>

        {/* Mensaje de confirmación */}
        {mensajeConfirmacion && (
          <div className="alert alert-info mt-4">{mensajeConfirmacion}</div>
        )}
      </div>

      {/* Modal de recuperación */}
      <div
        className="modal fade"
        id="modalRecuperar"
        tabIndex="-1"
        aria-labelledby="modalRecuperarLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="modalRecuperarLabel">
                Recuperar contraseña
              </h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Cerrar"></button>
            </div>
            <div className="modal-body">
              <input
                type="email"
                className="form-control"
                placeholder="Ingresa tu correo"
                value={emailRecuperacion}
                onChange={(e) => setEmailRecuperacion(e.target.value)}
              />
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                Cancelar
              </button>
              <button type="button" className="btn btn-primary" onClick={enviarRecuperacion} data-bs-dismiss="modal">
                Enviar
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* Cierre de Modal de Recuperacion */}
    </div>
  );
};

export default Login;
